import { createFileRoute } from "@tanstack/react-router"
import { zodValidator } from "@tanstack/zod-adapter"

import { ProductInventoryListPage } from "@/screens/Inventory/subfeatures/ProductInventory/components"
import { productInventoriesSearchSchema } from "@/screens/Inventory/subfeatures/ProductInventory/schemas"

export const Route = createFileRoute("/app/inventory/_layout/products")({
  validateSearch: zodValidator(productInventoriesSearchSchema),
  component: () => <ProductInventoryListPage />,
})
